import React, { FC, useEffect, useState } from 'react'
import { MenuComponent } from 'Pages/landings/common/components/Menu'
import { SliderComponent } from 'Pages/landings/credits/Slider'
import { IconListComponent } from 'Pages/landings/credits/IconList'
import { VideoComponent } from 'Pages/landings/credits/Video'
import { CreditListComponent } from 'Pages/landings/credits/CreditList'
import { NewsComponent } from 'Pages/landings/credits/News'
import { FormSectionComponent } from 'Pages/landings/common/components/FormSection'
import { ModalMessageComponent } from 'Pages/landings/common/components/ModalMessage'
import { useProducts } from 'Pages/landings/common/hooks/useProducts'
import { FooterComponent } from 'Pages/landings/common/components/Footer'
import { getQuery } from 'Pages/landings/common/helpers'
import { OutLinks } from 'Pages/landings/common/constants'
import { CookieHandlingNotice } from 'Pages/landings/common/components/CookieHandlingNotice'
import { GlobalStyle } from 'Pages/landings/common/styles/globalStyle'
import 'Pages/landings/credits/styles/credits.scss'

const menuItems = [
	{
		name: 'О кредитах',
		link: '#blockVideo',
	},
	{
		name: 'Продукты',
		link: '#blockCredits',
	},
	{
		name: 'Требования',
		link: '#blockNews',
	},
	{
		name: 'Подать заявку',
		link: '#blockForm',
	},
]

const LandingCredits: FC = () => {
	const [region, setRegion] = useState(null)
	const [seconds, setSeconds] = useState(0)
	const [message, setMessage] = useState({
		showMessage: false,
		title: null,
		subTitle: null,
		typeMessage: null,
		isClient: null,
		partnerRequestId: null,
	})

	const id = getQuery()?.partnerID
	const utmSource = getQuery().utm_source
	const requestId = getQuery().subpartnerID
	const regionsNoDivisions = []
	const { products } = useProducts(id)

	useEffect(() => {
		window.document.title = 'Кредиты'
	}, [])

	const onSendMessage = (
		typeMessage: string,
		title: string,
		subTitle: string,
		partnerRequestId: string,
		isClient?: null
	) => {
		if (typeMessage === 'success' && isClient) {
			setSeconds(5)
			setInterval(() => {
				setSeconds((second) => second - 1)
			}, 1000)
			setTimeout(() => {
				window.location.href = OutLinks.sberIsClient
			}, 5000)
		}
		setMessage({
			showMessage: true,
			title,
			subTitle,
			typeMessage,
			isClient,
			partnerRequestId,
		})
	}

	const onClearMessage = () =>
		setMessage({
			showMessage: false,
			title: null,
			subTitle: null,
			typeMessage: null,
			isClient: null,
			partnerRequestId: null,
		})

	return (
		<div className="landing-credits">
			<GlobalStyle />
			<MenuComponent setRegion={setRegion} region={region} menuItems={menuItems} />
			<SliderComponent />
			<IconListComponent />
			<VideoComponent />
			<CreditListComponent />
			<NewsComponent />
			<FormSectionComponent
				id={id}
				regionName={region?.name}
				regionId={region?.id}
				sendMessage={onSendMessage}
				products={products}
				regionsNoDivisions={regionsNoDivisions}
			/>
			{message.showMessage && (
				<ModalMessageComponent
					message={message}
					partnerID={id}
					revertShowForm={onClearMessage}
					seconds={seconds}
					utmSource={utmSource}
					requestId={requestId}
				/>
			)}
			<FooterComponent>
				Реклама. Рекламодатель ПАО Сбербанк. ИНН 7707083893. Кредиты предоставляет ПАО Сбербанк
				(далее Банк). Подача Заявки не гарантирует одобрение и выдачу кредита. Банк в праве отказать
				в кредите. Причины отказа являются банковской тайной и не разглашаются. Подробную информацию
				об услуге Вы можете получить в отделениях Банка, обслуживающих юридических лиц и
				индивидуальных предпринимателей, по телефону Контактного центра 8-800-555-57-77 (звонки по
				России — бесплатно) или на сайте Банка: http://www.sberbank.ru. ПАО СБЕРБАНК (ОГРН:
				1027700132195, 117312, г. Москва, ул. Вавилова, 19), АО «Деловая среда» (ОГРН:
				1127746271355, адрес места нахождения единоличного исполнительного органа: 117312, г.
				Москва, ул. Вавилова, д. 19) входит в группу компаний ПАО Сбербанк и выступает агентом Банка
				на основании агентского договора. Изменение условий производится Банком в одностороннем
				порядке. Информация, представленная в данном материале, не является публичной офертой Банка.
				Генеральная лицензия Банка России № 1481 от 11.08.2015.
			</FooterComponent>
			<CookieHandlingNotice />
		</div>
	)
}
export default LandingCredits
